import React, { useEffect, useState } from "react";
import { nav, brand } from "../mock";
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-4 left-0 right-0 z-50 px-4">
      <div className="mx-auto max-w-6xl">
        <div
          className={`flex items-center justify-between rounded-full pl-6 pr-2 py-2 transition-all duration-300 ${
            scrolled
              ? "bg-white/90 backdrop-blur-md shadow-lg"
              : "bg-white/70 backdrop-blur-sm shadow-md"
          }`}
        >
          <a href="#top" className="flex items-center select-none">
            <img
              src={brand.logo}
              alt="Grupo IFT"
              className="h-16 w-auto object-contain"
            />
          </a>

          <button
            onClick={scrollToContact}
            className="rounded-full bg-[#16204a] px-6 py-3 text-xs font-bold uppercase tracking-[0.12em] text-white transition-all duration-300 hover:bg-[#0f1738] hover:scale-[1.03] active:scale-95"
          >
            {nav.cta}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
